export function AdvisoriesLoading() {
  return (
    <div className="flex h-full w-full flex-1 flex-col gap-4 overflow-auto p-6">
      <div className="mb-5 ml-auto h-2 w-32 animate-pulse rounded-md bg-secondary-foreground" />
      <div className="mb-2 h-4 w-full animate-pulse rounded-md bg-secondary-foreground" />
      <div className="h-2 w-32 animate-pulse rounded-md bg-secondary-foreground" />
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          className="flex w-full flex-col gap-6 border border-stroke-line bg-surface-background p-4"
        >
          <div className="flex justify-between gap-2">
            <div className="h-2 w-64 animate-pulse rounded-md bg-secondary-foreground" />
            <div className="h-2 w-20 animate-pulse rounded-md bg-secondary-foreground" />
          </div>
          <div className="flex flex-col gap-2">
            <div className="my-1 h-4 w-2/3 animate-pulse rounded-md bg-secondary-foreground" />
            <div>
              <div className="my-2 h-2 w-full animate-pulse rounded-md bg-secondary-foreground" />
              <div className="my-2 h-2 w-full animate-pulse rounded-md bg-secondary-foreground" />
            </div>
            <div className="my-2 h-2 w-64 animate-pulse rounded-md bg-secondary-foreground" />
          </div>
        </div>
      ))}
    </div>
  );
}
